import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const obterMotoristaAplicativo = async (id, aplicativo = null) => {
  let url =
    process.env.URL_API_BASE +
    '/motorista-aplicativo/obter-por-motorista/' +
    id
  if (aplicativo) {
    url =
      process.env.URL_API_BASE +
      '/motorista-aplicativo/obter-por-motorista-e-codigo/' +
      id +
      '/' +
      aplicativo
  }
  let response = await axios.get(url, config)
  return response.data
}

const aprovarPerfil = async ({ cd_motorista, cd_aplicativo, observacao }) => {
  let response = await axios.patch(
    process.env.URL_API_BASE + '/motorista-aplicativo/aprovar',
    {
      cd_motorista: cd_motorista,
      cd_aplicativo: cd_aplicativo,
      observacao: observacao
    },
    config
  )
  return response.data
}

const inserirAplicativo = async ({
  cd_motorista,
  cd_aplicativo,
  cd_aplicativo_categoria,
  cd_aplicativo_segmento,
  viagens_realizadas,
  tempo_aplicativo,
  nota_motorista,
  idc_status
}) => {
  let response = await axios.post(
    process.env.URL_API_BASE + '/motorista-aplicativo',
    {
      cd_motorista: cd_motorista,
      cd_aplicativo: cd_aplicativo,
      cd_aplicativo_categoria: cd_aplicativo_categoria,
      cd_aplicativo_segmento: cd_aplicativo_segmento,
      viagens_realizadas: viagens_realizadas,
      tempo_aplicativo: tempo_aplicativo,
      nota_motorista: nota_motorista,
      idc_status: idc_status
    },
    config
  )
  return response.data
}

const reprovarPerfil = async ({ cd_motorista, cd_aplicativo, observacao }) => {
  let response = await axios.patch(
    process.env.URL_API_BASE + '/motorista-aplicativo/reprovar',
    {
      cd_motorista: cd_motorista,
      cd_aplicativo: cd_aplicativo,
      observacao: observacao
    },
    config
  )
  return response.data
}

const getUrlImagem = imgem => {
  return process.env.URL_IMG_PERFIL + '/' + imgem
}

const alterarMotoristaAplicativo = ({
  id,
  aplicativo,
  cd_aplicativo_categoria,
  cd_aplicativo_segmento,
  tempo_aplicativo,
  viagens_realizadas,
  nota_motorista
}) => {
  return axios.patch(
    process.env.URL_API_BASE + '/motorista-aplicativo/' + id + '/' + aplicativo,
    {
      cd_aplicativo_categoria: cd_aplicativo_categoria,
      cd_aplicativo_segmento: cd_aplicativo_segmento,
      tempo_aplicativo: tempo_aplicativo,
      viagens_realizadas: viagens_realizadas,
      nota_motorista: nota_motorista
    },
    config
  )
}

export default {
  obterMotoristaAplicativo,
  aprovarPerfil,
  reprovarPerfil,
  getUrlImagem,
  alterarMotoristaAplicativo,
  inserirAplicativo
}



// WEBPACK FOOTER //
// ./src/actions/MotoristaAplicativoActions.js